/* C-Monsta AOV draft — ladder + cart tile behaviour (8 Oct 2026) */
(function(){
  var CMS = window.CMS = window.CMS || {};
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';   // market-aware cart routes (/en-us/ in the US)
  function post(url, body){ return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){ if(!r.ok){ return r.json().then(function(j){ throw new Error(j.description||j.message||'Cart error'); }); } return r.json(); }); }
  CMS.add = function(items){ return post(R + 'cart/add.js',{items:items}); };
  // remove by VARIANT id in one /cart/update.js call: Shopify re-keys the remaining lines after every change, so removing two keys one after the other 400s on the second (found 12 Oct 2026)
  CMS.remove = function(keys){ if(!keys.length) return Promise.resolve(); var u={}; keys.forEach(function(k){ u[String(k).split(':')[0]] = 0; }); return post(R + 'cart/update.js',{updates:u}); };
  function busy(b,on){ if(b){ b.classList.toggle('busy',on); } }
  function go(){ window.location.href = R + 'cart'; }
  function err(e, b){ var m=(e&&e.message)||String(e); var host=b||document.activeElement; var n=document.createElement('p'); n.className='aov-err'; n.style.cssText='margin:8px 0 0;font-size:14px;color:#b00020'; n.textContent='Sorry, that did not work: '+m+'. Try again or add it from the product page.'; if(host&&host.insertAdjacentElement){ var old=host.parentNode&&host.parentNode.querySelector('.aov-err'); if(old) old.remove(); host.insertAdjacentElement('afterend', n); } }

  // ---------- ladders ----------
  document.addEventListener('click', function(e){
    var r = e.target.closest('.aov-rung');
    if(!r) return;
    var L = r.closest('.aov-ladder');
    L.querySelectorAll('.aov-rung').forEach(function(x){ x.classList.toggle('sel', x===r); });
    sync(L);
  });
  document.addEventListener('change', function(e){
    var L = e.target.closest('.aov-ladder'); if(L) sync(L);
  });
  document.addEventListener('click', function(e){
    var d = e.target.closest('.aov-ladder .aov-dot[data-col]'); if(!d) return;
    e.preventDefault(); var L=d.closest('.aov-ladder'); L.dataset.col=d.dataset.col;
    L.querySelectorAll('.aov-dot[data-col]').forEach(function(x){ x.classList.toggle('sel', x===d); if(x===d){ x.setAttribute('aria-current','true'); } else { x.removeAttribute('aria-current'); } });
    var cn=L.querySelector('.aov-colname'); if(cn) cn.textContent = L.dataset.mk==='us' ? (d.dataset.col==='Grey'?'Gray':d.dataset.col) : d.dataset.col;
    sync(L);
  });
  function sync(L){
    var sel = L.querySelector('.aov-rung.sel'); if(!sel) return;
    var k = sel.dataset.k;
    L.querySelectorAll('[data-for]').forEach(function(x){ x.style.display = x.dataset.for.split(',').indexOf(k)>=0 ? '' : 'none'; });
    var bp = L.querySelector('.aov-btn-price'); if(bp) bp.textContent = sel.dataset.price;
  }
  function singles(V,g,o){ var out=[]; if(g>0) out.push({id:V['single_Grey'],quantity:g}); if(o>0) out.push({id:V['single_Orange'],quantity:o}); return out; }
  function itemsFor(L){
    var sel = L.querySelector('.aov-rung.sel'); if(!sel) return [];
    var col = L.dataset.col || 'Grey';
    var kind = L.dataset.kind, k = sel.dataset.k;
    var V = JSON.parse(L.dataset.variants||'{}');
    if(kind==='hanger'){
      // Duo / Family Pack are real Shopify Bundles products (variant components fixed 12 Oct 2026): add the pack variant for the colour split.
      // Fallback: if a pack variant id is missing, add singles and let the Buy2 10% / Buy4 25% automatic discounts price them.
      if(k==='1') return col==='Orange' ? singles(V,0,1) : singles(V,1,0);
      if(k==='2'){ var m=(L.querySelector('#aov-duo-mix')||{}).value||'page'; var key = m==='page' ? (col==='Grey'?'GG':'OO') : m; var g2=(key.match(/G/g)||[]).length, o2=(key.match(/O/g)||[]).length; var dv=V['duo_'+key]; return dv ? [{id:dv,quantity:1}] : singles(V,g2,o2); }
      if(k==='4'){ var f=(L.querySelector('#aov-fam-mix')||{}).value||'page'; var fk = f==='page' ? (col==='Grey'?'G4O0':'G0O4') : f; var mm=fk.match(/G(\d)O(\d)/); var fv=V['fam_'+fk]; return fv ? [{id:fv,quantity:1}] : singles(V,+mm[1],+mm[2]); }
    }
    if(kind==='bag'||kind==='mat'){
      var w = (L.querySelector('input[name=aov-bag]:checked')||{}).value || L.dataset.bag || 's';
      if(k==='bag') return [{id:V['bag_'+w], quantity:1}];
      if(k==='mat') return [{id:V['mat'], quantity:1}];
      if(k==='pair') return [{id:V['pair_'+w], quantity:1}];
      if(k==='baghanger') return [{id:V['bh_'+w+'_'+col], quantity:1}];
      if(k==='kit') return [{id:V['kit_'+w+'_'+col], quantity:1}];
    }
    if(kind==='mini'||kind==='minimat'){
      var cv = (L.querySelector('input[name=aov-cover]:checked')||{}).value || 'Red';
      if(k==='mini') return [{id:V['mini'], quantity:1}];
      if(k==='minimat') return [{id:V['minimat'], quantity:1}];
      if(k==='pair') return [{id:V['minipair'], quantity:1}];
      if(k==='trio') return [{id:V['trio_'+cv], quantity:1}];
    }
    if(kind==='tough'){
      // C-Monsta Tough Hanger (19 Oct 2026): 5 Pack of this colour; 'Mix your boxes' = n grey + m orange 5-pack boxes as plain lines (Shipbots sees the 5-pack SKUs); 25 Pack of this colour
      if(k==='5') return [{id:V['t5_'+col], quantity:1}];
      if(k==='mix'){ var mg=mixCount('g'), mo=mixCount('o'), out=[]; if(mg>0) out.push({id:V['t5_Grey'],quantity:mg}); if(mo>0) out.push({id:V['t5_Orange'],quantity:mo}); return out; }
      if(k==='25') return [{id:V['t25_'+col], quantity:1}];
    }
    if(kind==='kit'){
      if(k==='1') return [{id:V['kit'], quantity:1}];
      if(k==='2') return [{id:V['kit'], quantity:1},{id:V['single_'+col], quantity:1}];
    }
    return [];
  }
  // ---------- Tough Hanger: mix your boxes (19 Oct 2026) ----------
  function mixCount(c){ var el=document.getElementById('aov-mix-'+c); return el ? (parseInt(el.textContent,10)||0) : 0; }
  function mixMoney(box, cents){ var sym=box.dataset.sym||'$'; return sym+(cents/100).toFixed(2); }
  function mixRender(L){
    var box=document.getElementById('aov-mixbox'); if(!box) return;
    var g=mixCount('g'), o=mixCount('o'), n=g+o, unit=+box.dataset.unit, post=+box.dataset.post, pw=box.dataset.postword||'shipping';
    var price=unit*n, per=Math.round(price/(n*5));
    var sum=document.getElementById('aov-mix-sum'); if(sum) sum.textContent=(n*5)+' hangers · '+mixMoney(box,price)+' · '+mixMoney(box,per)+' a hanger · '+(n>=2 ? 'free '+pw : '+ '+mixMoney(box,post)+' '+pw);
    var pr=document.getElementById('aov-mix-price'), sm=document.getElementById('aov-mix-small');
    if(pr) pr.textContent = n>=2 ? mixMoney(box,price) : mixMoney(box,price+post);
    if(sm){ sm.textContent = n>=2 ? 'Free '+pw : 'delivered'; sm.style.color = n>=2 ? '' : '#777'; }
    var rung=L.querySelector('.aov-rung[data-k="mix"]'); if(rung) rung.dataset.price=mixMoney(box,price);
    var note=document.getElementById('aov-mix-note'); if(note) note.hidden = !(n>=4);
    var cap=document.getElementById('aov-mix-cap'); if(cap) cap.hidden = !(n>=4);
    box.querySelectorAll('.aov-step').forEach(function(s){ var d=+s.dataset.d, c=s.dataset.c, cur=c==='g'?g:o; s.disabled = (d>0 && n>=4) || (d<0 && (cur<=0 || n<=1)); });
    sync(L);
  }
  document.addEventListener('click', function(e){
    var s=e.target.closest('.aov-step'); if(!s) return; e.preventDefault(); if(s.disabled) return;
    var el=document.getElementById('aov-mix-'+s.dataset.c); var g=mixCount('g'), o=mixCount('o'), v=(s.dataset.c==='g'?g:o)+(+s.dataset.d);
    if(v<0) v=0; var other=s.dataset.c==='g'?o:g; if(v+other<1||v+other>4) return; el.textContent=v;
    var L=s.closest('.aov-ladder'); var rung=L.querySelector('.aov-rung[data-k="mix"]'); if(rung && !rung.classList.contains('sel')){ L.querySelectorAll('.aov-rung').forEach(function(x){ x.classList.toggle('sel', x===rung); }); }
    mixRender(L);
  });
  document.addEventListener('click', function(e){
    var a=e.target.closest('.aov-to25'); if(!a) return; e.preventDefault();
    var L=a.closest('.aov-ladder'); var r=L.querySelector('.aov-rung[data-k="25"]'); if(!r) return;
    L.querySelectorAll('.aov-rung').forEach(function(x){ x.classList.toggle('sel', x===r); }); sync(L); r.scrollIntoView({behavior:'smooth',block:'center'});
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest('.aov-add'); if(!b) return;
    e.preventDefault(); var L=b.closest('.aov-ladder'); var items=itemsFor(L).filter(function(i){return i.id;});
    if(!items.length){ err('Nothing to add (missing variant id)', b); return; }
    busy(b,true); CMS.add(items).then(go).catch(function(x){ busy(b,false); err(x, b); });
  });

  // ---------- cart tiles ----------
  document.addEventListener('click', function(e){
    var b = e.target.closest('.aov-tile .aov-btn[data-items]'); if(!b) return;
    e.preventDefault(); busy(b,true);
    var items = JSON.parse(b.dataset.items||'[]'); var rm = JSON.parse(b.dataset.remove||'[]');
    CMS.remove(rm).then(function(){ return CMS.add(items); }).then(function(){ window.location.href = R + 'cart?t=' + Date.now(); }).catch(function(x){ busy(b,false); err(x, b); });
  });

  // gift line under every product-page ladder (12 Oct 2026): the buyer is often not the user
  function giftLine(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var link='<a href="'+root+'pages/gifts" style="color:#16191D;text-decoration:underline">Find the right gift →</a>';
    document.querySelectorAll('.aov-ladder .aov-gift').forEach(function(g){ if(!g.querySelector('a')) g.insertAdjacentHTML('beforeend', ' '+link); });
    document.querySelectorAll('.aov-ladder .aov-add').forEach(function(btn){
      if(btn.closest('.aov-ladder').querySelector('.aov-gift')) return;
      var p=document.createElement('p'); p.className='aov-gift';
      p.style.cssText='margin:10px 0 0;font-size:14px;line-height:1.4;color:#555;text-align:center';
      p.innerHTML='Buying for someone? 🎁 One size fits every wetsuit. '+link;
      btn.insertAdjacentElement('afterend', p);
    });
  }
  // two Duos in the basket: swap them for the Family Pack (same colours, pack price) once, then show why (Mark, 13 Oct 2026)
  function autoFam(){
    var a=document.getElementById('aov-auto'); if(!a) return;
    var items=JSON.parse(a.dataset.items||'[]'), rm=JSON.parse(a.dataset.remove||'[]');
    if(!items.length||!rm.length) return;
    try{ if(sessionStorage.getItem('aov-auto-fam')===location.pathname+rm.join()) return; sessionStorage.setItem('aov-auto-fam', location.pathname+rm.join()); }catch(e){}
    CMS.remove(rm).then(function(){ return CMS.add(items); }).then(function(){ window.location.href = R + 'cart?fam=1&t=' + Date.now(); }).catch(function(){});
  }
  function famNote(){
    if(!/[?&]fam=1/.test(location.search)) return; var c=document.getElementById('aov-cart'); if(!c) return;
    var n=document.createElement('p'); n.className='aov-note'; n.style.cssText='font-weight:700;color:#16191d'; n.textContent='Four hangers? We’ve made that a Family Pack 🙌'; c.insertAdjacentElement('afterbegin', n);
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.aov-ladder').forEach(sync); document.querySelectorAll('.aov-ladder[data-kind="tough"]').forEach(mixRender); giftLine(); autoFam(); famNote();
    if(document.getElementById('aov-ladder')) document.body.classList.add('aov-has-ladder');
    if(document.getElementById('aov-shop')) document.body.classList.add('hide-collection-grid');
  });
})();
